'use strict';

/* eslint no-undef: "off" */
/**
 * XPark homepage api
 */
define('xparkHomepageApi',['baseApiGet', 'baseApiPost', 'axios', 'appStorage', 'util'], function (baseApiGet, baseApiPost, axios, appStorage, Util) {
  var API_PREFIX = '/rest/V1/xpark-app';
  var silentOptions = { noLoading: true };

  function getRequestClient() {
    var client = axios.create({
      headers: {
        'Content-Type': 'application/json',
        'X-Ab-Version': Util.getCookie('ab_version') === '' ? 'default' : Util.getCookie('ab_version')
      },
      timeout: 30000
    });

    if (appStorage.token()) {
      client.defaults.headers.common.Authorization = 'Bearer ' + appStorage.token();
    }

    if (typeof ga !== 'undefined' && ga.getAll && ga.getAll()[0]) {
      client.defaults.headers.common['X-TrackerId'] = ga.getAll()[0].get('clientId');
    }

    return client;
  }

  function appendQuery(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var query = Object.keys(params).filter(function (key) {
      return params[key] !== undefined && params[key] !== null && params[key] !== '';
    }).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    if (!query) {
      return url;
    }

    return url + (url.indexOf('?') > -1 ? '&' : '?') + query;
  }

  function getCommonParams() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return Object.assign({
      version: appStorage.getConfig().device
    }, params);
  }

  return {
    getHomepageSort: function getHomepageSort() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-sort', params, silentOptions);
    },
    getHeroBanner: function getHeroBanner() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-banners', params, silentOptions);
    },
    getAnnouncements: function getAnnouncements() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-announcements', params, silentOptions);
    },
    getServicePromise: function getServicePromise() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-service-promise', params, silentOptions);
    },
    getBrandStory: function getBrandStory() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-brand-story', params, silentOptions);
    },
    getTrendingNow: function getTrendingNow() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-trending-now', params, silentOptions);
    },
    getBrandPromotion: function getBrandPromotion() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-brand-promotion', params, silentOptions);
    },
    getFlashSales: function getFlashSales() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/flash-sales', params, silentOptions);
    },
    getClassificationFloor: function getClassificationFloor() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-classification-floor', params, silentOptions);
    },
    getProductFloor: function getProductFloor() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-product-floor', params, silentOptions);
    },
    getDiscoverMore: function getDiscoverMore() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-discover-more', params, silentOptions);
    },
    getInfinixCommunity: function getInfinixCommunity() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/bbs', params, silentOptions);
    },
    getFaqItems: function getFaqItems() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/web-homepage-faq-items', params, silentOptions);
    },
    getOfflineStores: function getOfflineStores() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/offline-stores', params, silentOptions);
    },
    getReserveList: function getReserveList() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/reserve', params, silentOptions);
    },
    getCouponActivities: function getCouponActivities() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiGet(API_PREFIX + '/coupon-activity', params, silentOptions);
    },
    fetchCoupon: function fetchCoupon(ruleId) {
      var client = getRequestClient();
      var requestUrl = appendQuery(API_PREFIX + '/coupon-fetch', getCommonParams({
        rule_id: ruleId
      }));

      return client.post(requestUrl).then(function (resp) {
        if ((resp.status === 200 || resp.status === 401) && resp.data) {
          if (resp.data.code == 200 || resp.data.status == 1) {
            return resp.data;
          }
          return Promise.reject(resp.data);
        }

        return Promise.reject(resp && resp.data || {});
      }, function (error) {
        if (error && error.response && error.response.data) {
          return Promise.reject(error.response.data);
        }

        return Promise.reject(error || {});
      });
    },
    submitReserve: function submitReserve() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return baseApiPost(API_PREFIX + '/reserve', params);
    }
  };
});
